
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "61285f8e-1660-4fe0-9b95-cb5348fa39fa"
  },
  "ui": {
    "primary": "green",
    "gray": "cool",
    "colors": [
      "green",
      "red",
      "primary"
    ],
    "strategy": "merge"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/tmp/build/d411e185/code/app.config.js"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
